module.exports = {"id":"189860","name":"Kiko Femenía","rating":"76","photo":"./data/images/photos/0/189860.png","club":{"name":"Watford","logo":"./data/images/clubs/Watford.png"},"positions":["DD","DLD","MD"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/KikoFemenia0.json
// module id = 2374
// module chunks = 0